import { render, staticRenderFns } from "./pdfRedirect.vue?vue&type=template&id=75686e18&scoped=true"
import script from "./pdfRedirect.vue?vue&type=script&lang=js"
export * from "./pdfRedirect.vue?vue&type=script&lang=js"
import style0 from "./pdfRedirect.vue?vue&type=style&index=0&id=75686e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75686e18",
  null
  
)

export default component.exports